module.exports = __webpack_public_path__ + "static/media/7.0341b3c4.JPG";